/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopCompanyInvoicesDto
 */
export interface TopCompanyInvoicesDto {
    /**
     * 
     * @type {string}
     * @memberof TopCompanyInvoicesDto
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof TopCompanyInvoicesDto
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof TopCompanyInvoicesDto
     */
    totalIssuedGross: string;
    /**
     * 
     * @type {number}
     * @memberof TopCompanyInvoicesDto
     */
    invoiceCount: number;
}

/**
 * Check if a given object implements the TopCompanyInvoicesDto interface.
 */
export function instanceOfTopCompanyInvoicesDto(value: object): value is TopCompanyInvoicesDto {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('totalIssuedGross' in value) || value['totalIssuedGross'] === undefined) return false;
    if (!('invoiceCount' in value) || value['invoiceCount'] === undefined) return false;
    return true;
}

export function TopCompanyInvoicesDtoFromJSON(json: any): TopCompanyInvoicesDto {
    return TopCompanyInvoicesDtoFromJSONTyped(json, false);
}

export function TopCompanyInvoicesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopCompanyInvoicesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'companyName': json['companyName'],
        'totalIssuedGross': json['totalIssuedGross'],
        'invoiceCount': json['invoiceCount'],
    };
}

export function TopCompanyInvoicesDtoToJSON(value?: TopCompanyInvoicesDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'totalIssuedGross': value['totalIssuedGross'],
        'invoiceCount': value['invoiceCount'],
    };
}

